import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import Barcode from "react-barcode";
import { API_URL } from "../../common/Config";
import { colors } from "@mui/material";

const Order_Receipt_sticker = (props) => {
  const params = useParams();
  const productId = props.product_id || params.product_id;

  const [product, setProduct] = useState({
    name: "",
    size: "",
    code: "",
    price: "",
    rate: "",
    outer_ean_number: "",
  });

  const currencySymbol = localStorage.getItem("currencySymbol") || "₹";
  const stickerRef = useRef(null);

  // Set to your printer's width (e.g., "58mm", "76mm", "80mm")
  const stickerWidth = "100mm";
  const stickerHeight = "70mm";
  const token = localStorage.getItem("token");
  useEffect(() => {
    if (productId) {
      fetch(`${API_URL}/get_product_details/${productId}`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
        .then((res) => res.json())
        .then((data) => {
          const prod = data.data || data;
          setProduct({
            name: prod.name || "",
            size: prod.size || "",
            code: prod.code || "",
            price: prod.price || "",
            rate: prod.rate || "",
            outer_ean_number: prod.outer_ean_number || "",
          });
        })
        .catch(() => {
          setProduct({
            name: "",
            size: "",
            code: "",
            price: "",
            rate: "",
            outer_ean_number: "",
          });
        });
    }
  }, [productId]);
const ean = product.outer_ean_number;
let barcodeFormat = "EAN13";
let barcodeValue = null;

if (/^\d{13}$/.test(ean)) {
  barcodeValue = ean;
  barcodeFormat = "EAN13";
} else if (/^\d{14}$/.test(ean)) {
  barcodeValue = ean;
  barcodeFormat = "ITF14"; // Will only work if the Barcode library supports it
}
  const handlePrint = () => {
    if (stickerRef.current) {
      const printContents = stickerRef.current.innerHTML;
      const printWindow = window.open("", "", "width=400,height=600");
      printWindow.document.write(`
        <html>
        <head>
          <title>Print Sticker</title>
          <style>
            @media print {
              html, body {
                width: ${stickerWidth} !important;
                height: ${stickerHeight} !important;
                margin: 5px;
                padding: 3px;
                background: #fff;
              }
              .price-sticker {
                width: 100% !important;
                height: 100% !important;
                border: 1px solid #000;
                border-radius: 8px;
                background: #fff;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
                box-sizing: border-box;
                font-family: Arial, sans-serif;
                padding: 0.4cm;
                font-size: 18px;
                gap: 0.2cm;
              }
            }
          </style>
        </head>
        <body>
          <div class="price-sticker">
            ${printContents}
          </div>
          <script>
            window.onload = function() {
              window.print();
              window.close();
            };
          </script>
        </body>
        </html>
      `);
      printWindow.document.close();
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        background: "#f5f5f5",
      }}
    >
      <div
        className="price-sticker"
        ref={stickerRef}
        style={{
          width: stickerWidth,
          height: stickerHeight,
          borderRadius: "8px",
          border: "1px solid #000",
          background: "#fff",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "flex-start",
          boxSizing: "border-box",
          fontFamily: "Arial, sans-serif",
          padding: "0.4cm",
          fontSize: "15px",
          gap: "0.2cm",
          marginTop: "2rem",
        }}
      >
        {/* ...existing sticker content... */}
        {/* Product Name, Size & Code, Price, Barcode */}
        {/* ...existing code... */}
        <div
          style={{
            fontWeight: "bold",
            fontSize: "1.2em",
            width: "100%",
            textAlign: "center",
          }}
        >
          {product.name}
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <span>
            <strong>Size:</strong> {product.size}
          </span>
          <span>
            <strong>Code:</strong> {product.code}
          </span>
        </div>
        <div style={{ textAlign: "center", width: "100%" }}>
          <div style={{ fontSize: "1.6em", fontWeight: "bold" }}>
            {product.price
              ? `${currencySymbol}${parseFloat(product.price).toFixed(2)}`
              : ""}
          </div>
          <div style={{ fontSize: "0.9em", fontWeight: "normal" }}>
            {product.rate
              ? `Incl. VAT ${parseFloat(product.rate).toFixed(0)}%`
              : ""}
          </div>
        </div>
        <div style={{ alignSelf: "center", fontSize: "12px" }}>
              
      
  {barcodeValue ? (
    <Barcode
      value={barcodeValue}
      format={barcodeFormat}
      height={40}
      width={1.4}
      fontSize={12}
      displayValue={true}
      margin={0}
    />
  ) : (
    <div style={{ height: "1.2cm", color: "red", fontSize: "0.8em" }}>
      Invalid EAN
    </div>
  )}

          {/* {product.outer_ean_number &&
          /^[0-9]{13}$/.test(product.outer_ean_number) ? (
            <Barcode
              value={product.outer_ean_number}
              format="EAN13"
              height={40}
              width={1.4}
              fontSize={12}
              displayValue={true}
              margin={0}
            />
          ) : (
            <div style={{ height: "1.2cm", color: "red", fontSize: "0.8em" }}>
              Invalid EAN
            </div>
          )} */}
        </div>
      </div>
      {/* Button after sticker */}
      <div style={{ width: "100%", textAlign: "center", margin: "2rem 0" }}>
        <button
          style={{
            backgroundColor: "#417f7e",
            color: "#fff",
            padding: "6px 12px",
            fontSize: "0.8rem",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
          onClick={handlePrint}
        >
          Print Sticker
        </button>
      </div>
    </div>
  );
}

export default Order_Receipt_sticker;
